// @flow
import React from 'react';
import Box from "@material-ui/core/Box";
import { TYPE } from '../../constants/targetConstants';
import DeferRender from '../ui/DeferRender';
import TargetList from './TargetList';

export type Props = $ReadOnly<{
    planes: $ReadOnlyArray<string>
}>;

function Planes({ planes }: Props) {
    return (
        <Box mx={2} pb={5}>
            <DeferRender>
                <TargetList items={planes} type={TYPE.plane} />
            </DeferRender>
        </Box>
    );
}

export default Planes;